import { ScopeOfPracticeEnum } from '@umss/shared/utils';
import { PagedRequestDto } from '../paged-request.model';
import { BillingStatus } from '../payments.model';

export interface TimesheetRequest extends PagedRequestDto {
  contractorId: string;
  facilityId: string;
  status: BillingStatus;
  startDate: string;
  endDate: string;
  scopeOfPractice: ScopeOfPracticeEnum;
  year: number;
  invoiceId: number;
}
